// 画面で表示するメッセージをここで定義
// ボタンのテキスト等もここに含める

export const APP_NAME = "SUKIDANA";

export const ERROR_MESSAGES = {
  CATEGORY_ALREADY_EXISTS: "この名前はすでに存在します",
  COPY_TO_CLIPBOARD_FAILED: "クリップボードへのコピーに失敗しました",
  COUNT_OVER_NAME_LENGTH: "15文字以内で入力してください",
  COUNT_OVER_TITLE_LENGTH: "10文字以内で入力してください",
  NO_INPUT: "値を入力してください",
  UNSUPPORTED_LINK: "非対応の商品リンクなので、コンテンツとして登録できません",
  IRREGULAR_INPUT: "入力した値が不正です",
  IRREGULAR_ID: "SNS IDの形式が不正です\n正しいIDを入力してください",
  TOO_MANY_REQUESTS:
    "通信が混雑しています\n1分ほど待ってから再度お試しください",
  REQUIRES_RECENT_LOGIN:
    "前回ログインから時間が経っています\n再度ログインしてからアカウントの削除をしてください",
  SYSTEM_ERROR:
    "システムエラーが発生しました\nしばらくしてから再度お試しください",
  SYSTEM_ERROR_FOR_DELETE_ACCOUNT:
    "システムエラーが発生しました\n再度ログインしてからアカウントの削除をしてください",
  THIRD_PARTY_COOKIE_ERROR:
    "ログインに失敗しました\nthird-party cookie の設定が無効になってる可能性があります\nブラウザの設定をご確認ください",
  USER_ALREADY_EXISTS: "このユーザはすでに存在します",
  USER_NOT_FOUND: "該当するユーザが存在しません",
  USER_NOT_REGISTERED: "ユーザが登録されていません\n新規登録をしてください",
  NO_RESULTS:
    "検索結果が見つかりませんでした\nカテゴリを絞り込むか、検索ワードを変えてお試しください\nそれでも見つからない場合は負荷が集中しているので、\nしばらく時間を置いてからお試しください",
};

export const SUCCESS_MESSAGES = {
  DELETE_ACCOUNT: "アカウントを削除しました",
};

export const ABOUT_APP = `${APP_NAME}は\nあなたの「好き」をあつめて\n人に伝える無料サービスです\n\nSNSのプロフィールに書ききれない\nあなたの「好き」を本棚のように飾って\n共有しましょう`;

export const DETAIL_APP = `趣味はゲームです。\n趣味は読書です。\n趣味は映画です。\n・・で、結局どんなのが好きなの？\nそう思ったことはありませんか？\n\n${APP_NAME}は一言では伝えきれない、\n掘り下げた「好き」を表現するサービスです。\n\nあなたイチオシの趣味で、\nSUKIDANAを埋めてみてください。\nあなたが作った素敵なSUKIDANAを\n共有してください。\n気が合う人が作ったSUKIDANAを見て\n新たな「好き」を見つけてください。\n\n全ての趣味人が「好き」を一目で説明でき、\n新しい「好き」と出会えるサービスを\n${APP_NAME}は目指しています。`;

export const TERMS_OF_USE =
  "利用規約\n\n1.定義：\n　この利用規約を「本規約」といいます。\n　このWebサイト上で提供されるサービスを「本サービス」といいます。\n　本サービスを利用する方を「ユーザー」といいます。\n　本サービスを提供する者を「管理者」といいます。\n\n2.本サービスについて：\n　本サービスはユーザーの一歩踏み込んだ趣味の詳細、好きを共有し合うことで新たなユーザの繋がり、新たなコンテンツの発掘を目的としたウェブサービスです。\n　管理者はプロモーション等を通じて本サービスの認知力向上、ユーザーの利便性の向上に寄与できるよう努力します。\n\n3.禁止事項：\n　本サービスの利用にあたり、以下の行為を禁止します。\n　　他人にIDおよびパスワードを譲渡、貸与すること\n　　IDを不特定多数で共有すること\n　　他のユーザーを不快にさせる行為を行うこと\n　　本サービスの障害となる行為を行うこと\n　　その他、法令や公序良俗に反する行為を行うこと\n\n4.本サービスの利用および停止等：\n　本サービスは、利用者が本規約に違反した場合、その利用者について本サービスの一部または全部を停止することがあります。\n　　この場合、管理者はユーザーに対し通知する義務を負いません。\n　本サービスは、過去に本規約の違反等によって利用停止等の処分を受けたユーザーに対して、本サービスの利用停止をすることができます。\n　　この場合、管理者はユーザーに対し通知する義務を負いません。\n　本サービスは、障害対応やメンテナンス等を行う場合、本サービスの一部または全部を停止することがあります。\n　　この場合、管理者はユーザーに対し合理的な手段により本サービスを停止する旨の通知をします。\n　本サービスは、ユーザーに対して事前に通知することなく、本サービスの機能の一部を停止、または中断することができます。\n\n5.ユーザーの責務：\n　ユーザーは本サービスの利用にあたり、ユーザー自身が一切の法的な責任を負い、本規約に対する違反等によって生じる一切の責任を負う物とします。\n　ユーザーは本規約に違反し、本サービスに費用負担または損害を与えた場合、発生したあらゆる費用を負担するものとします。\n\n5. 免責事項：\n　管理者は、本サービスに事実上または法律上のあらゆる瑕疵（安全性・信頼性・正確性・完全性・有効性・特定の目的への適合性・セキュリティなどに関する欠陥・エラーやバグ・権利侵害など）がないことを保証しておりません。\n　管理者は、本サービスに起因してユーザーに生じたあらゆる損害について一切の責任を負いません。\n　管理者は、管理者の過失によってユーザーに生じたあらゆる損害について一切の責任を負いません。\n　管理者は、本サービスに起因してユーザーと他のユーザーまたは第三者との間において生じたあらゆる取引、連絡または紛争などについて一切責任を負いません。\n\n6. 個人情報：\n　本サービスではログインおよび共有でのみTwitterユーザ情報を利用します。\n　また、情報の管理は「Google Firebase」を利用しております。\n　Google Firebaseの利用規約・プライバシーポリシーについてはこちら ( https://firebase.google.com/support/privacy?hl=ja )をご確認ください。\n\n7.本サービス内容および本利用規約の変更：\n　管理者の判断により、本サービスは内容を変更する可能性があります。\n　管理者の判断により、本規約は内容を変更する可能性があります。\n　変更後の本規約は、管理者が別途定める場合を除き、本サービス上に表示した時点より効力を生じるものとします。";

export const DIALOG_TITLE = {
  ADD_CONTENT: "コンテンツを追加",
  DELETE_ACCOUNT: "アカウントを削除しますか？",
  DELETE_CONTENT: "このコンテンツを削除しますか？",
  DELETE_CONTENT_LIST: "この棚を削除しますか？",
  SHARE: "SUKIDANAを共有",
  SETTING_SNS: "SNSアカウント設定",
  SETTING_USER_NAME: "ユーザ名を入力してください",
  SETTING_CONTENT_LIST_NAME: "SUKIDANAの名前は？",
};

export const BUTTON_TEXT = {
  ADD: "追加",
  DECIDE: "決定",
  COPY: "コピー",
  SAVE: "保存",
  DETAIL_APP: `${APP_NAME}について詳しく知る`,
  OK: "OK",
  PLUS: "+",
  TWITTER_LOGIN: "Twitterログイン",
  DELETE: "削除",
  CANCEL: "キャンセル",
  SEARCH: "検索",
  SEARCH_MORE: "更に表示",
  CONTACT: "お問い合わせフォームはこちら",
  TERMS_OF_USE: "利用規約"
};

export const MENU_TEXT = {
  CONTACT: "お問い合わせ",
  CHANGE_PROFILE: "ユーザ名変更",
  DELETE_ACCOUNT: "アカウント削除",
  SETTING_SNS: "SNSアカウント設定",
  SIGN_OUT: "ログアウト",
};

export const PLACEHOLDER_TEXT = {
  INPUT_AMAZON_LINK: "AmazonのURLを入力",
  INPUT_SEARCH_WORD: "検索ワードを入力",
  INPUT_SNS_ID: "SNSのIDを入力",
  CONTENT_LIST_NAME_SAMPLE: "例：積みゲー、神映画、推し本",
};

// 注釈
export const NOTES = {
  NAME_LIMIT: "※15文字以内で入力",
  TITLE_LIMIT: "※10文字以内で入力",
  SEARCH_NOTE: "※カテゴリを設定しないと失敗する可能性が高いです",
  SEARCH_NOTE_NEWLINE: "※カテゴリを設定しないと\n　失敗する可能性が高いです",
  URL_NOTE: "※短縮URLは登録できません",
  LOGIN_NOTE:
    "※本サービスではログインおよびツイートでの共有でのみ\n　Twitterユーザ情報を利用します。その他の情報は収集しません。",
  LOGIN_NOTE_MOBILE:
    "※本サービスではログインおよびツイートでの共有でのみTwitter\n　ユーザ情報を利用します。その他の情報は収集しません。",
};

export const TOOLTIPS = {
  RANDOM: "誰かの棚を見てみる",
  SHARE: "Twitterで自分のSUKIDANAを共有する",
  ADD: "新しい棚を追加する",
  EDIT: "棚の中身を編集する",
  DELETE: "表示中の棚を削除する"
};

export const COPY_TO_CLIPBOARD = "クリップボードにコピーしました";
